import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-eventPromotion",
  id: "event-promotion-component"
}
const _hoisted_2 = { class: "o-eventPromotion__heading" }
const _hoisted_3 = { class: "o-eventPromotion__form" }
const _hoisted_4 = {
  key: 1,
  class: "o-eventimPromotion__selectionWrapper"
}
const _hoisted_5 = { class: "o-eventPromotion__selection a-formGroup" }
const _hoisted_6 = {
  key: 2,
  class: "o-eventPromotion__footer"
}
const _hoisted_7 = { class: "a-notice__error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_SelectionComponent = _resolveComponent("SelectionComponent")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_TextInputComponent = _resolveComponent("TextInputComponent")!
  const _component_button_component = _resolveComponent("button-component")!
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.promotionStore.availablePromotions.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          (_ctx.activePromotion)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _withDirectives((_openBlock(), _createElementBlock("h3", null, [
                  _createTextVNode("Promotion: " + _toDisplayString(_ctx.activePromotion.name), 1)
                ])), [
                  [_directive_translate, {
                    key: _ctx.Translation.Promotion_selected_promotion_interface_title,
                    keyValues: JSON.stringify({ promotionName: _ctx.activePromotion.name })
                }]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("p", null, [
                  _createTextVNode("Redeem offered benefits")
                ])), [
                  [_directive_translate, { key : _ctx.Translation.Promotion_selected_promotion_interface_subtitle }]
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _withDirectives((_openBlock(), _createElementBlock("h3", null, [
                  _createTextVNode("Do you have any promotional codes?")
                ])), [
                  [_directive_translate, { key: _ctx.Translation.Promotion_interface_title }]
                ]),
                _withDirectives((_openBlock(), _createElementBlock("p", null, [
                  _createTextVNode("Select promotion and enter your promotion code.")
                ])), [
                  [_directive_translate, { key : _ctx.Translation.Promotion_interface_subtitle }]
                ])
              ], 64))
        ], 512), [
          [_vShow, _ctx.promotionStore.showHeader]
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.promotionStore.spinner)
            ? (_openBlock(), _createBlock(_component_SpinnerComponent, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.promotionStore.active !== null)
                  ? (_openBlock(), _createBlock(_component_SelectionComponent, {
                      key: 0,
                      value: _ctx.activePromotionLabel,
                      onRemove: _ctx.handleRemoval
                    }, null, 8, ["value", "onRemove"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_VueMultiselect, {
                          "model-value": _ctx.promotionStore.selection,
                          options: _ctx.promotionStore.availablePromotions,
                          searchable: false,
                          clearable: false,
                          "allow-empty": true,
                          placeholder: _ctx.selectionPlaceholder,
                          label: "name",
                          "track-by": "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSelection($event))),
                          "select-label": "",
                          "deselect-label": ""
                        }, null, 8, ["model-value", "options", "placeholder"])
                      ]),
                      (_ctx.selection)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["a-formGroup", { 'is-button-group' : !_ctx.selection.isCodeRequired }])
                          }, [
                            (_ctx.selection.isCodeRequired)
                              ? (_openBlock(), _createBlock(_component_TextInputComponent, {
                                  key: 0,
                                  label: _ctx.inputPlaceholder,
                                  name: 'promotion-code',
                                  value: _ctx.inputValue,
                                  "has-submit-action": true,
                                  "input-qa-selector": _ctx.PerformanceQASelectors.PROMOTION_CODE,
                                  "action-qa-selector": _ctx.PerformanceQASelectors.PROMO_ARROW,
                                  onInput: _ctx.handleInput,
                                  onSubmit: _ctx.handleSubmit
                                }, null, 8, ["label", "value", "input-qa-selector", "action-qa-selector", "onInput", "onSubmit"]))
                              : (_openBlock(), _createBlock(_component_button_component, {
                                  key: 1,
                                  label: _ctx.applyButtonLabel,
                                  active: _ctx.canSubmit,
                                  type: _ctx.ButtonType.Action,
                                  onSubmit: _ctx.applyNonValidatingPromotion
                                }, null, 8, ["label", "active", "type", "onSubmit"]))
                          ], 2))
                        : _createCommentVNode("", true)
                    ])),
                (_ctx.promotionStore.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.promotionStore.error), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]))
    : _createCommentVNode("", true)
}